<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="68"
      viewBox="0 0 75 68"
      fill="none"
    >
      <path
        d="M67.6841 16.3342H57.5806L51.7479 9.95969H32.6244V16.3342H48.9431L54.7758 22.7087H67.6841V60.9556H16.6882V32.2704H10.3137V60.9556C10.3137 64.4616 13.1822 67.3301 16.6882 67.3301H67.6841C71.1901 67.3301 74.0586 64.4616 74.0586 60.9556V22.7087C74.0586 19.2027 71.1901 16.3342 67.6841 16.3342ZM26.2499 41.8322C26.2499 50.629 33.3894 57.7684 42.1862 57.7684C50.983 57.7684 58.1224 50.629 58.1224 41.8322C58.1224 33.0354 50.983 25.8959 42.1862 25.8959C33.3894 25.8959 26.2499 33.0354 26.2499 41.8322ZM42.1862 32.2704C47.4451 32.2704 51.7479 36.5732 51.7479 41.8322C51.7479 47.0911 47.4451 51.3939 42.1862 51.3939C36.9272 51.3939 32.6244 47.0911 32.6244 41.8322C32.6244 36.5732 36.9272 32.2704 42.1862 32.2704ZM16.6882 16.3342H26.2499V9.95969H16.6882V0.397949H10.3137V9.95969H0.751953V16.3342H10.3137V25.8959H16.6882V16.3342Z"
        fill="#080816"
        fill-opacity="0.38"
      />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
